import { LocalDateTime } from '@js-joda/core';
import DateUtils from 'src/utils/date';

export class PlanModel {
    planUid: string;
    created: LocalDateTime;
    updated: LocalDateTime;
    currentScenarioUid: string;
    defaultScenarioUid: string;
    addedAccountsAt: LocalDateTime;
    addAccountsLastDismissed: LocalDateTime;
    addAccountsTimesDismissed: number;
    isTypeFull: boolean;
    isTypeBudgeting: boolean;

    public static serialize(): string {
        return JSON.stringify(this);
    }

    public static deserialize(input: string): PlanModel {
        const plan: PlanModel = JSON.parse(input);
        return this.deserializeDates(plan);
    }

    public static deserializeDates(plan: PlanModel): PlanModel {
        if (plan.created) {
            plan.created = DateUtils.datetimeify(plan.created);
        }

        if (plan.updated) {
            plan.updated = DateUtils.datetimeify(plan.updated);
        }

        if (plan.addedAccountsAt) {
            plan.addedAccountsAt = DateUtils.datetimeify(plan.addedAccountsAt);
        }

        if (plan.addAccountsLastDismissed) {
            plan.addAccountsLastDismissed = DateUtils.datetimeify(plan.addAccountsLastDismissed);
        }

        return plan;
    }
}
